<template>
    <div :class="locationClass" v-on:click="$emit('filled-out', item.id)">
        <div class="row">
            <div class="col-lg-10">
                <ul class="list-unstyled" style="margin:0">
                    <li><strong>{{getItemName}}</strong></li>
                    <li>{{item.address}}</li>
                </ul>
            </div>
            <div class="col-lg-2 button-column"><button
                class="btn-step-select"
                :value="item.id"
                >Select</button></div>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      item: {},
      value: '',
    },
    methods: {
        test() {
            return this.$vssWidth < 415;
        }
    },
    computed: {
        ...mapState('form', { form: 'form'}),
        getValueId() {
            return this.value ? this.value.id : '';
        },
        getItemName() {
            return this.item.id === 0 && this.form.integrationFormType ? "Show all " + this.form.integrationFormType + "s" : this.item.name;
        },
        locationClass() {
            return {
                "step-fields-list-box-item": true,
                "locations" : true,
                "selected": this.getValueId===this.item.id
            };
        }
    }
  };
</script>
<style>
@media only screen and (max-width: 770px) {
    .step-fields-list-box-item .col-lg-10 {
        max-width:83.333333%;
    }
    .step-fields-list-box-item .col-lg-2 {
        max-width:16.666667%;
    }
    body .step-fields-list-box-item.locations {
        padding-left:0;
        padding-right:0;
    }
}
</style>
